// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const InstantAccessGroups = registerClientReference(
    function() { throw new Error("Attempted to call InstantAccessGroups() from the server but InstantAccessGroups is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/instant-access-groups.tsx <module evaluation>",
    "InstantAccessGroups",
);
